$(document).ready(function() {
	$('.item-w-child').hover(
		function() {
			//$(this).find('.menu-child').fadeIn(300);
			$('header .section-component-values').hide();
			heightResize();
		},
		function() {
			//$(this).find('.menu-child').hide();
			$('header .section-component-values').show();
			heightResize();
		}
	);

	function heightResize() {
		let getHeight = $('header').height();
		$('#main-content').css({'padding-top': getHeight+'px'});
	}

	heightResize();

	$(window).resize(function() {
		heightResize();
	});

	$('.grid-close').click(function() {
		heightResize();
	});

	$('.mobile-drawer .item-parent a.prevent').click(function(e) {
		e.preventDefault();
		$(this).next('.menu-child').toggleClass('open');
		$('.mobile-drawer').toggleClass('open-child');
		$('.mobile-drawer').animate({ scrollTop: 0 }, 0);
	});

	$('.close-menu-child').click(function() {
		$('.menu-child').removeClass('open');
		$('.mobile-drawer').removeClass('open-child');
	});

	$('.mobile-menu-drawer').click(function() {
		$('.mobile-drawer').addClass('open');
	});

	$('.close-menu').click(function() {
		$('.mobile-drawer').removeClass('open');
		$('.menu-child').removeClass('open');
		$('.mobile-drawer').removeClass('open-child');
	});

	$('.item-title.returns').click(function() {
		$(this).toggleClass('active');
		$('.returns_info').toggleClass('active');
	});

	$('video').click(function() {
		this[this.paused ? 'play' : 'pause']();
		$(this).parent('.item-video').find('.icon-container .icon').toggleClass('active');
	});

	$('.icon-play').click(function() {
		let parent = $(this).parent().parent();
		let vd = $(this).parent().parent().find('video');
		vd.get(0).play();
		parent.find('.icon-container .icon').toggleClass('active');
	});

	$('.icon-pause').click(function() {
		let parent = $(this).parent().parent();
		let vd = $(this).parent().parent().find('video');
		vd.get(0).pause();
		parent.find('.icon-container .icon').toggleClass('active');
	});

	// Function to handle click events
  /*function handleClick(event) {
      // Check if the clicked element has the specified class or ID
      if (
          event.target.id === 'AddToCart' ||
          event.target.classList.contains('spf-product__form-btn-addtocart') ||
          event.target.classList.contains('upsell-cart__item-remove') ||
          event.target.id === 'cart-icon-bubble'
      ) {
          // Handle the click event for the specific element
          //console.log('Clicked on: ' + event.target.tagName);
          obsidian:upsell:quantity
      }
  }

  // Add a click event listener to the document
  document.addEventListener('click', handleClick);*/

	$(document).on('click','.single_add_to_cart_button, .spf-product__form-btn-addtocart, .upsell-cart__item-remove, #cart-icon-bubble', function() {
		setTimeout(function() {
			$.ajax({
	      type: 'GET',
	      url: '/cart.js', // Shopify cart data endpoint
	      dataType: 'json',
	      success: function(cartData) {
	        var totalProducts = 0;

	        // Loop through each item in the cart and accumulate the total
	        $.each(cartData.items, function(index, item) {
	          totalProducts += item.quantity;
	        });

	        // Output the total to the console or display it on your webpage
	        //console.log('Total Products in Cart: ' + totalProducts);
	        $('.bubble').text(totalProducts);
	      },
	      error: function(error) {
	        console.log('Error fetching cart data: ' + error);
	      }
	    });
		}, 500);
	});
});